var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EFF6F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 41.6667C37.4318 41.6667 34.9444 39.1794 34.9444 36.1111C34.9444 33.0429 37.4318 30.5556 40.5 30.5556C43.5682 30.5556 46.0556 33.0429 46.0556 36.1111C46.0556 39.1794 43.5682 41.6667 40.5 41.6667ZM40.5 33.3333C38.9659 33.3333 37.7222 34.577 37.7222 36.1111C37.7222 37.6452 38.9659 38.8889 40.5 38.8889C42.0341 38.8889 43.2778 37.6452 43.2778 36.1111C43.2778 34.577 42.0341 33.3333 40.5 33.3333ZM41.2778 58.0972C41.5839 57.8912 41.7955 57.5719 41.8658 57.2097C41.9362 56.8476 41.8595 56.4723 41.6528 56.1667C31.3889 40.8889 30.7778 39.8194 30.7778 36.1111C30.7778 32.7639 33.3611 27.7778 40.5 27.7778C47.6389 27.7778 50.2222 32.7639 50.2222 36.1111C50.2222 39.1806 49.9583 40.2778 43.0556 50.6528C42.6804 51.2873 42.8664 52.1044 43.4791 52.5141C44.0919 52.9239 44.918 52.7835 45.3611 52.1944C52.0694 42.1389 53 40.1806 53 36.1111C53 31.8194 49.6111 25 40.5 25C31.3889 25 28 31.8194 28 36.1111C28 40.75 28.9583 42.3194 39.3472 57.7222C39.5532 58.0283 39.8725 58.2399 40.2347 58.3103C40.5969 58.3806 40.9722 58.304 41.2778 58.0972Z",
    fill: "#31795A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.56ee76cd4998db17e053d38c748786f6.svg";
export { ForwardRef as ReactComponent };